import { connect } from 'react-redux'
import { replace } from 'react-router-redux'

import PrivacyAgreement from '../../components/privacy/privacy-agreement'

function mapStateToProps (state, ownProps) {
  return {}
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    handleClose () {
      dispatch(replace('/login'))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyAgreement)



// WEBPACK FOOTER //
// ./src/containers/privacy/privacy-agreement-container.js